import { makeReducer } from '../utils/redux.tools';
import { PagesActions } from '../actions/pages.actions';

export const initialState = {
    pages: [],

    isCreating: false,
    createSuccess: false,
    createError: null,

    isDeleting: false,
    deleteSuccess: false,
    deleteError: null,

    isUpdating: false,
    updateSuccess: false,

    siteNavUpdating: false,
    siteNavSuccess: false,
    siteNavError: null,

    indexUpdating: false,
    indexSuccess: false,

    error: null,

    index: undefined
};

const pagesRed = {
    /*~~~~ FETCH_PAGES ~~~~*/
    [PagesActions.FETCH_PAGES]: (state, payload) => ({
        ...state,
        pages: payload
    }),

    /*~~~~ CREATE_PAGES ~~~~*/
    [PagesActions.IS_CREATING]: state => ({
        ...state,
        isCreating: true,
        createSuccess: false,
        createError: null
    }),
    [PagesActions.CREATE_PAGE_SUCCESS]: state => ({
        ...state,
        isCreating: false,
        createSuccess: true,
        createError: null
    }),
    [PagesActions.CREATE_PAGE_ERROR]: (state, payload) => ({
        ...state,
        isCreating: false,
        createError: payload
    }),
    [PagesActions.CLEAR_PAGE_CREATION_STATE]: state => ({
        ...state,
        isCreating: undefined,
        createSuccess: undefined,
        createError: undefined
    }),

    /*~~~~ DELETE_PAGES ~~~~*/
    [PagesActions.IS_DELETING]: state => ({
        ...state,
        isDeleting: true,
        deleteSuccess: false,
        deleteError: null
    }),
    [PagesActions.DELETE_PAGE_SUCCESS]: state => ({
        ...state,
        isDeleting: false,
        deleteSuccess: true,
        deleteError: null
    }),
    [PagesActions.DELETE_PAGE_ERROR]: (state, payload) => ({
        ...state,
        isDeleting: false,
        deleteError: payload
    }),
    [PagesActions.CLEAR_PAGE_DELETION_STATE]: state => ({
        ...state,
        isDeleting: undefined,
        deleteSuccess: undefined,
        deleteError: undefined
    }),

    /*~~~~ UPDATE_PAGES ~~~~*/
    [PagesActions.IS_UPDATING]: state => ({
        ...state,
        isUpdating: true,
        updateSuccess: false,
        error: null
    }),
    [PagesActions.UPDATE_PAGES_SUCCESS]: state => ({
        ...state,
        isUpdating: false,
        updateSuccess: true,
        error: null
    }),
    [PagesActions.UPDATE_PAGES_ERROR]: (state, payload) => ({
        ...state,
        isUpdating: false,
        updateSuccess: false,
        error: payload
    }),
    [PagesActions.CLEAR_PAGE_UPDATE_STATE]: state => ({
        ...state,
        isUpdating: undefined,
        updateSuccess: undefined,
        error: undefined
    }),

    /*~~~~ PUBLISH_SITE_NAV ~~~~*/
    [PagesActions.PUBLISH_SITE_NAV]: state => ({
        ...state,
        siteNavUpdating: true,
        siteNavSuccess: false,
        siteNavError: null
    }),
    [PagesActions.PUBLISH_SITE_NAV_SUCCESS]: state => ({
        ...state,
        siteNavUpdating: false,
        siteNavSuccess: true,
        siteNavError: null
    }),
    [PagesActions.PUBLISH_SITE_NAV_ERROR]: (state, payload) => ({
        ...state,
        siteNavUpdating: false,
        siteNavSuccess: false,
        siteNavError: payload
    }),
    [PagesActions.CLEAR_PUBLISH_SITE_NAV]: state => ({
        ...state,
        siteNavUpdating: false,
        siteNavSuccess: false,
        siteNavError: null
    }),

    /*~~~~ INDEX_PAGE ~~~~*/
    [PagesActions.FETCH_INDEX]: (state, payload) => ({
        ...state,
        index: payload.index
    }),
    [PagesActions.SET_INDEX_PAGE]: state => ({
        ...state,
        indexUpdating: true,
        indexSuccess: false,
        error: null
    }),
    [PagesActions.PUBLISH_INDEX_PAGE]: state => ({
        ...state,
        indexUpdating: true,
        indexSuccess: false,
        error: null
    }),
    [PagesActions.SET_INDEX_SUCCESS]: state => ({
        ...state,
        indexUpdating: false,
        indexSuccess: true,
        error: null
    }),
    [PagesActions.SET_INDEX_ERROR]: (state, payload) => ({
        ...state,
        indexUpdating: false,
        indexSuccess: false,
        error: payload
    })
};

export const pagesReducer = makeReducer('Pages', initialState, pagesRed);
